import { ApiAnswerRequest, ApiMultilangString } from '../../../types/ApiTypes';
import { IAnswer, Langs, MultilangString } from '../../../types/GlobalTypes';
import { findValueByLang } from '../../findValueByLang/findValueByLang';
import { groupAnswersById } from './groupAnswersById';

// GMT-791: answer content is sent in every supported language (PL fallback),
// not only pl/en/ua
const getAnswerContent = (answers: MultilangString[]): ApiMultilangString => {
  const plValue = findValueByLang({ lang: Langs.PL, array: answers }) as string;

  return Object.values(Langs).reduce((acc, lang) => {
    acc[lang] = findValueByLang({ lang, array: answers }) || plValue;
    return acc;
  }, {} as Record<string, string>);
};

export const prepareQuestionAnswers = ({
  correctAnswers,
  incorrectAnswers,
}: {
  correctAnswers: IAnswer[];
  incorrectAnswers: IAnswer[];
}) => {
  const answers: ApiAnswerRequest[] = [];

  groupAnswersById(correctAnswers).forEach(item => {
    answers.push({
      isCorrect: true,
      content: getAnswerContent(item.answers),
    });
  });

  groupAnswersById(incorrectAnswers).forEach(item => {
    answers.push({
      isCorrect: false,
      content: getAnswerContent(item.answers),
    });
  });

  return answers;
};
